export default __webpack_public_path__ + "static/media/reports.a351c5e6.svg";